import { request } from '@/shared/api/request'

export const sendReject = (data) =>
    request({ url: `contract/persCard/employee/sendReject`, method: 'POST', data})
